import React from "react";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const FileUploader = ({
	accept = "*",
	multiple = false,
	handleUpload,
}: {
	accept?: string;
	multiple?: boolean;
	handleUpload: (files: File[]) => void;
}) => {
	const { t } = useTranslation(["common"]);
	const theme = useTheme();
	const inputRef = React.useRef<HTMLInputElement>(null);
	const [fileOver, setFileOver] = React.useState(false);

	const handleFiles = (files: FileList | null) => {
		const validFiles = Array.from(files);

		inputRef.current.value = "";
		if (validFiles.length === 0) {
			return;
		}
		handleUpload(validFiles);
	};
	const handleFileInputChange = (event) => {
		const { files } = event.target;

		handleFiles(files);
	};
	const handleDragOver = (event) => {
		event.preventDefault(); // Prevent default behavior (Prevent file from being opened)
	};

	const handleDrop = (event) => {
		event.preventDefault();
		setFileOver(false);
		const { files } = event.dataTransfer;
		handleFiles(files);
	};

	return (
		<>
			<Box
				ref={inputRef}
				component={"input"}
				type="file"
				id="file-input"
				accept={accept}
				multiple={multiple}
				display="none"
				onChange={handleFileInputChange}
			/>
			<Box
				className="drop-zone"
				id="drop-zone"
				border={"2px dashed " + theme.palette.divider}
				borderRadius={1}
				width={1}
				height={150}
				display="flex"
				justifyContent="center"
				alignItems="center"
				textAlign="center"
				position="relative"
				onClick={() => inputRef.current.click()}
				onDragOver={handleDragOver}
				onDragEnter={() => setFileOver(true)}
				onDragLeave={() => setFileOver(false)}
				onDrop={handleDrop}
				sx={{ cursor: fileOver ? "copy" : "pointer", "&:hover": { border: "2px dashed " + theme.palette.primary.main } }}>
				{fileOver ? t("dropDescription") : t("drop&SelectDescription")}
			</Box>
		</>
	);
};

export default FileUploader;
